//
// The "flight" object bellow contains all the data necessary to do flihts between the points defined as scenes.
//
// It contains three fully independent arrays:
//   scenes: must contain all the points potentially available for flights. For manually conducted flights
//           the only needed properties are: id, center, lonLat, zoom, minZoom, maxZoom. Zoom gives the initial
//           level of zoom, but the image layer will be visible only inside the interval [minZoom, maxZoom].
//   layers: currently contains the satellite images product, but it could include later all kind of data layers
//   prod:   it is a FeatureCollection including all the descriptive objects (pictos, text, boxes, lines ...)
//           created by the user. The features are only visible for zoom level bigger than 9 (could be changed).
//
// All the data inside can be manually modified but initially are created by the "globe-anim" production tool
//

// For test purposes, the variables below have few available options each, the names are auto-desciptive

const S3_BUCKET_URL = "https://skylight-dev-public-assets.s3.amazonaws.com";

// const IMAGES_PRODUCTS = `${S3_BUCKET_URL}/ol-flight/images-tci-cropped-12-15/`; // aws s3 url
const IMAGES_PRODUCTS = `${S3_BUCKET_URL}/ol-flight/images-products-cropped-12-15/`; // aws s3 url
// const IMAGES_PRODUCTS = "/data/images-tci-cropped-12-15/";
// const IMAGES_PRODUCTS = "/data/images-tci-products-12-15/";
// const IMAGES_PRODUCTS = "/data/images-tci-full/";

// const bkgnd_source = { sourceName: "osm", url: null };
// const bkgnd_source = {
//    sourceName: "xyz",
//    url: "https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
// };
const bkgnd_source = {
  sourceName: "xyz",
  url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
};

const flight = {
  id: "87d30129-38c5-494b-b0e8-6800368f2551",
  name: "Site - COG-3857 sm",
  scenes: [
    {
      id: "27cb97c6-024c-4ac3-829d-1c431cb342fd",
      center: [2934678.6110646795, 5474226.597996602],
      name: "Giurgiu",
      lonLat: [26.3626665029805, 44.05673720028176],
      zoom: 13,
      minZoom: 12,
      maxZoom: 15,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 8,
      delay: 3,
      description:
        "<h2>Normalized Difference Moisture Index for stress</h2> <h5>July 23, 2021 - Giurgiu Romania</h5><p>Derived from NDMI, this index can be mainly used for determining if a certain parcel has been irrigated or not. The color palette has only four classes allowing us to differentiate between productive and non-productive surfaces. It is useful for tracking the concessions of water resources used for irrigation.</p>",
    },
    {
      id: "34a2c477-eee5-4c4f-aad8-7b36cd46cbc5",
      center: [3300651.46771992, 6646725.6773575805],
      name: "Chernobyl",
      lonLat: [29.65025661004335, 51.14355131120024],
      zoom: 12.166666666666671,
      minZoom: 12,
      maxZoom: 15,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 8,
      delay: 3,
      description:
        "<h2>Forest fires - Wildfires visualization</h2> <h5>March 23, 2022 - Chernobyl, Ukraine</h5><p>The wildfires have broken out in the forest surrounding the Chernobyl nuclear plant, where a catastrophic accident occurred in 1986, and have spread across hundreds of acres of land in the exclusion zone. They have raised concerns about the potential release of radioactive materials from the site.</p>",
    },
    {
      id: "4942a685-1967-46b8-b959-91db7c56b05f",
      center: [9789759.714580001, 10892541.970534118],
      name: "Norilsk",
      lonLat: [87.94290779464778, 69.45164306856296],
      zoom: 13,
      minZoom: 12,
      maxZoom: 15,
      mode: null,
      easing: null,
      duration: 3,
      delay: 3,
      description:
        "<h2>Oil spills - Enhanced True Color Image</h2> <h5>Mai 31, 2020 - Norilsk, Russia</h5><p>Diesel oil spills (red color in the river) are a significant environmental concern in Siberia, as they can cause considerable damage to the region's fragile ecosystems and have a range of negative impacts, including the contamination of soil, water, and permafrost, the destruction of habitat for plants and animals.</p>",
    },
    {
      id: "24893cc1-903a-4ba0-8c79-53ea9e74d513",
      center: [9213570.839186909, 1975550.1785612085],
      name: "Pentakota, India",
      lonLat: [82.76691506159524, 17.469529073943704],
      zoom: 13.863122829049878,
      minZoom: 12,
      maxZoom: 15,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 3,
      delay: 3,
      description:
        "<h2>Normalized Difference Vegetation Index</h2> <h5>April 25, 2022 - Pentakota, India</h5><p>Based on Near Infra Red (NIR) reflectance measurements, this index is sensitive to the leaf internal structure and leaf dry matter content but not to the water content of the leaf. Remote monitoring is much cheaper than on-site controlling on large surfaces and gives the possibility of fast and efficient supervision activities in the farms.</p>",
    },
    {
      id: "8ef45804-2fc5-436e-a0d4-d66f00ef9451",
      center: [13142554.447787939, -4155331.8338506334],
      name: "Albany, SW Australia",
      lonLat: [118.06157532820902, -34.93706514206413],
      zoom: 12.938750424231191,
      minZoom: 12,
      maxZoom: 15,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 3,
      delay: 3,
      description:
        "<h2>Normalized Difference Moisture Index</h2> <h5>December 19, 2021 - SW Australia</h5><p>The NDMI is mainly useful to detect the crop’s water stress, being a reliable indicator of the moisture level in different areas of the parcels. NDMI depends on the type of crop and its phenological stage, that’s why the most important is comparing different values within the same parcel in order to identify problems related to water stress.</p>",
    },
    {
      id: "6a2be785-b06c-4b29-b45e-790599d6c1e3",
      center: [3800874.5717927474, 3444.8952220161664],
      name: "Kenya",
      lonLat: [34.143837208626664, 0.030946018796697672],
      zoom: 13.035532432017607,
      minZoom: 9,
      maxZoom: 28,
      mode: null,
      easing: null,
      duration: 3,
      delay: 3,
      description:
        "<h2>Normalized Difference Water Index</h2> <h5>May 31, 2020 - Siaya, Kenya</h5><p>The NDWI is used to monitor changes related to water content in water bodies, or to monitor the wide areas of land which were underwater in Busia and Siaya counties, western Kenya after the Nzoia river overflowed. 237 people died in flooding in Kenya in April and May while over 100,000 have been displaced.</p>",
    },
    {
      id: "8d203aba-2a53-44b0-bc9f-4b0494eb01e4",
      center: [-5828606.726112186, -345775.7680808743],
      name: "Amazon",
      lonLat: [-52.359265071884224, -3.1046361849678163],
      zoom: 12.659008845837555,
      minZoom: 9,
      maxZoom: 28,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 8,
      delay: 3,
      description:
        "<h2>Barren Soil Index</h2> <h5>July 07, 2019 - Para state, Brazil (Amazon basin)</h5><p>This index displays barren ground in red, allowing us to detect recent deforestation or monitor droughts. It is also used to assess the degree of soil degradation caused by various factors such as erosion, compaction, and loss of organic matter.</p>",
    },
    {
      id: "f2c137c3-66ad-45d0-9b7a-8ca99f2a2fb0",
      center: [-12373952.82773862, 5405167.942323929],
      name: "Rocky Mountains",
      lonLat: [-111.15710950131574, 43.60923331068315],
      zoom: 14.138585123461263,
      minZoom: 9,
      maxZoom: 28,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 8,
      delay: 3,
      description:
        "<h2>Enhanced Vegetation Index</h2> <h5>August 10, 2021 - Rocky Mountains, USA</h5><p>Rather similar to NDVI, used to monitor healthy vegetation, this index is supposed to minimize the influence of atmosphere (aerosols, cloud cover, and cloud shadow) and soil (brightness and color) influence in the index value, and also to avoid situations like dense canopy zones when NDVI reaches saturation.</p>",
    },
    {
      id: "6cf2b165-7137-41ce-a95d-7fd04cd214a7",
      center: [-4817660.907137421, 8651771.917677686],
      name: "Greenland",
      lonLat: [-43.277784265866636, 61.11280885495441],
      zoom: 13,
      minZoom: 9,
      maxZoom: 28,
      mode: {
        name: "Fly to",
        code: "fly-to",
      },
      easing: null,
      duration: 3,
      delay: 3,
      description:
        "<h2>True Color Image</h2> <h5>April 4, 2022 - SE Greenland</h5><p>Large sections of ice breaking off and separating from the ice cap as a result of global warming can be observed in this image.</p>",
    },
  ],
  layers: [
    {
      category: "bkgnd",
      key: "B-0",
      name: "Background Map",
      opacity: 100,
      sourceName: bkgnd_source.sourceName,
      url: bkgnd_source.url,
      preload: 4,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-0",
      name: "TCI - Giurgiu, Romania",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "romania-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-6",
      name: "TCI - Chernobyl, Ukraine",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "tchernobyl-3857.tif",
          nodata: 0,
        },
      ],
      style: {
        brightness: 53,
        contrast: 39,
        gamma: 5,
        saturation: 50,
        exposure: 50,
      },
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-1",
      name: "TCI - Norilsk, Russia",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "norilsk-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
      palette: null,
      style: {
        brightness: 50,
        contrast: 50,
        gamma: 15,
        saturation: 75,
        exposure: 68,
      },
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-8",
      name: "TCI - Pentakota, E-India",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "india-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-4",
      name: "TCI - SW-Australia",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "australia-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-3",
      name: "TCI - Kenya",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "kenya-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-5",
      name: "TCI - Para state, Brazil",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "brazil-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-2",
      name: "TCI - Rocky Mountains, Driggs, Idaho",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "driggs-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
    },
    {
      category: "polar",
      group: "Images TCI cropped 12-15",
      key: "P-7",
      name: "TCI - S-Greenland",
      opacity: 100,
      sourceName: "cog-3857",
      sources: [
        {
          url: IMAGES_PRODUCTS + "greenland-3857.tif",
          nodata: 0,
        },
      ],
      minZoom: 0,
      maxZoom: 15,
      palette: null,
      style: {
        brightness: 40,
        contrast: 72,
        gamma: 26,
        saturation: 89,
        exposure: 42,
        palette: null,
      },
    },
  ],
  prod: {
    type: "FeatureCollection",
    features: [],
  },
  description:
    "Cropped area, toate imaginile sunt reproiectate deja in EPSG-3857",
  maxZoom: 15,
  featuresMinZoom: 9,
  activeWidth: 500,
  activeHeight: 500,
};
